import Flickity from "flickity";

const HomeSlidesWithVideo = { 

  _selectors: {
    carousel: '.js-home-slide-video-block',
    slide: '.js-home-slide-video-slide',
    slidesContainer: '.js-home-slide-video-slides',
    indicatorContainer: '.js-home-slide-video-navigation',
    linkSelector: '.js-home-slide-video-link',
    progressBarSelector: '.js-home-slide-video-progress-bar'
  },

  _slideDuration: 5500,
  _flickity: null,

  init() {
    this.setupFlickity()
    this.setupPagination();

  },

  setupFlickity() {
    const homeSlideCarousel = document.querySelector(this._selectors.carousel);

    if (parseInt(homeSlideCarousel.getAttribute('data-video-length'))) {
      this._slideDuration = parseInt(homeSlideCarousel.getAttribute('data-video-length')) * 1000
    }


    this._flickity = new Flickity(homeSlideCarousel.querySelector(this._selectors.slidesContainer), {
      adaptiveHeight: false,
      setGallerySize: false,
      autoPlay: this._slideDuration,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false, 
      wrapAround: true, 
      accessibility: false,
      // on: {
      //   // adds/removes active class to indicators 
      //   change: (currentDotIndex) => {
      //     document.querySelectorAll(this._selectors.progressBarSelector).forEach((bar, index) => {
      //       if (currentDotIndex > index) {
      //         bar.classList.add('previous')
      //         bar.classList.remove('current');
      //         bar.style.animationDuration = '';
      //       }
      //       else if (currentDotIndex === index) {
      //         bar.classList.remove('previous');
      //         bar.classList.remove('current');
      //         bar.classList.add('current')
      //         bar.style.animationDuration = self._slideDuration + 'ms';
      //       } else {
      //         bar.classList.remove('previous')
      //         bar.classList.remove('current')
      //         bar.style.animationDuration = '';
      //       }
      //     })
      //   }
      // }
    })

    this._flickity.pausePlayer()

    window.addEventListener('load', () => {
      this.initializeSlider()
    })

    window.addEventListener('resize', () => {
      this.initializeSlider()
    })

  },

  initializeSlider() {
    const self = this;

    this._flickity.resize()

    this._flickity.select( 0 );
    this._flickity.on('change', (currentDotIndex) => {
      document.querySelectorAll(this._selectors.progressBarSelector).forEach((bar, index) => {
        if (currentDotIndex > index) {
          bar.classList.add('previous')
          bar.classList.remove('current');
          bar.style.animationDuration = '';
        }
        else if (currentDotIndex === index) {
          bar.classList.remove('previous');
          bar.classList.remove('current');
          bar.classList.add('current')
          bar.style.animationDuration = self._slideDuration + 'ms';
        } else {
          bar.classList.remove('previous')
          bar.classList.remove('current')
          bar.style.animationDuration = '';
        }
      })
    })
    this._flickity.unpausePlayer()

    const firstSlideNavigation = document.querySelector(this._selectors.progressBarSelector)



    firstSlideNavigation.classList.add('current');
    firstSlideNavigation.style.animationDuration = this._slideDuration + 'ms'
  },

  setupPagination() {
    document.querySelector(this._selectors.indicatorContainer).addEventListener('click', (e) => {
      
      if (!e.target.matches(this._selectors.linkSelector)) {
        return; 
      }

      console.log('Hello!', e.target.getAttribute('data-index'));      ;

      this._flickity.pausePlayer();
      this._flickity.select( e.target.getAttribute('data-index') );
      this._flickity.unpausePlayer();
    })
  }

}

export default HomeSlidesWithVideo;